// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root-loading-main {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  height: 100vh;
  width: 100vw;
  background-color: var(--color-white);
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Loading/index.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,oCAAA;AACF","sourcesContent":[".root-loading-main {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99999;\n  height: 100vh;\n  width: 100vw;\n  background-color: var(--color-white);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
